import isEmpty from "../../validation/is-empty";
import {
  caHeaderTitles as headerTitles,
  Cell,
  Row,
  Table,
} from "./BenchmarkElementAnalysisView.functions";
import "./BenchmarkElementAnalysisView.css";
import PropTypes from "prop-types";
import { formatNumber } from "./Benchmark.functions";

BenchmarkCarbonAnalysisView.propTypes = {
  rowData: PropTypes.object,
};

export function BenchmarkCarbonAnalysisView(props) {
  const { rowData } = props;
  let headerRow = [];
  let rows = [];
  if (isEmpty(rowData)) {
    return (
      <div className="no-data-available">
        <i className="fas fa-thumbs-down" /> No Carbon Analysis Data Available
      </div>
    );
  }

  //get All codes from category groups
  prepareCarbonAnalysisTable(rowData, headerRow, rows);

  return <Table rows={rows} headerRow={headerRow}></Table>;
}

prepareCarbonAnalysisTable.propTypes = {
  rowData: PropTypes.object,
  headerRow: PropTypes.array,
  rows: PropTypes.array,
};
export function prepareCarbonAnalysisTable(row_Data, headerRow, rows) {
  let ui = 0;
  let cells = [];

  let sorted_rowData = row_Data.sort((a, b) => {
    const intA = parseFloat(a.code, 10); // Convert 'value' property of object 'a' to an integer
    const intB = parseFloat(b.code, 10); // Convert 'value' property of object 'b' to an integer
    return intA - intB; // Sort in ascending order
  });
  let rowData = sorted_rowData;

  Object.entries(headerTitles).forEach(([key, value]) => {
    let className = "info-table-cell header " + value.type;
    cells.push(
      <Cell
        key={ui++}
        content={value.content}
        cellSpecificClass={className}
        isReporting={value.isReport}
      ></Cell>
    );
  });
  headerRow.push(<Row key="header" Cells={cells}></Row>);
  rowData.forEach((element, rowIndex) => {
    cells = [];
    cells.push(getCell(headerTitles, element));
    rows.push(<Row key={ui++} Cells={cells} rowSpecificClass={""}></Row>);
  });

  /** Internal functions section  */
  function getCell(headerTitles, element) {
    return Object.entries(headerTitles).map(([key, value]) => {
      let cellContent = "";
      cellContent = formatNumber(value.type, element[`${key}`]);
      return (
        <Cell
          key={ui++}
          content={cellContent}
          cellSpecificClass={value.type}
          isReporting={value.isReport}
        ></Cell>
      );
    });
  }
}
